"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { useEffect, useRef, useState } from "react";
export default function WelcomeToOurTermsOfService() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: subtitleRef,
    isVisible: subtitleVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: buttonRef,
    isVisible: buttonVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const parallaxRef = useRef<HTMLDivElement>(null);
  const [parallaxOffset, setParallaxOffset] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current) {
        const rect = parallaxRef.current.getBoundingClientRect();
        const scrollSpeed = 0.5;
        const offset = (window.scrollY - rect.top) * scrollSpeed;
        setParallaxOffset(offset);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section ref={parallaxRef} className="relative w-full py-16 overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1375869/img/modern_clinic_hallway.png)]" style={{
      transform: `translateY(${parallaxOffset * 0.05}px)`
    }} />

      {}
      <div className="absolute inset-0 bg-secondary/10" />

      {}
      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center justify-center text-center space-y-6">
        {}
        <h1 ref={headlineRef} className={`text-4xl md:text-5xl lg:text-6xl font-display font-bold text-foreground max-w-4xl transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          IronPeak Men's Health
        </h1>

        {}
        <Separator className="w-48 bg-muted-light" />

        {}
        <div ref={subtitleRef} className={`space-y-3 transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${subtitleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-2xl md:text-3xl font-display font-semibold text-foreground">
        </h2>
          <p className="text-base md:text-lg text-foreground max-w-2xl">
        </p>
          <p className="text-sm md:text-base text-foreground">
        </p>
        </div>

        {}
        <div ref={buttonRef} className="w-full flex justify-center pt-4">
          <Link to="#legal-terms">
            
          </Link>
        </div>
      </div>
    </section>;
}